import React from 'react'
import PropTypes from 'prop-types'
import { faExclamation } from '@fortawesome/pro-solid-svg-icons'
import { Box, Typography } from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import { alpha } from '@material-ui/core/styles'
import AvatarIcon from './AvatarIcon'

const useStyles = makeStyles({
  container: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
})

const ErrorMessage = ({
  icon,
  iconColor,
  title = 'Look’s like something went wrong.',
  subtitle = 'Try refreshing the page or contacting an administrator for help.',
}) => {
  const theme = useTheme()
  const styles = useStyles()

  return (
    <Box className={styles.container}>
      <Box pb={2}>
        <AvatarIcon
          icon={icon || faExclamation}
          color={iconColor || alpha(theme.palette.common.black, 0.26)}
          size="lg"
        />
      </Box>
      <Typography variant="h6">{title}</Typography>
      <Typography
        variant="body2"
        color="textSecondary"
      >
        {subtitle}
      </Typography>
    </Box>
  )
}

ErrorMessage.propTypes = {
  icon: PropTypes.any,
  iconColor: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
}

export default ErrorMessage
